import { AcceptedLanguage } from './enums/accepted-language.enum';

export function base64EncodeUnicode(str: string): string {
  return Buffer.from(unescape(str)).toString('base64');
}

export function padZero(value: number, numberDigits: number) {
  return (
    Array(Math.max(numberDigits - String(value).length + 1, 0)).join('0') +
    value
  );
}

export function flattenValues(obj: { [key: string]: any }): any[] {
  const flattenRecurse = (obj: { [key: string]: any }): any[] => {
    return Object.values(obj).map((val) => {
      if (val instanceof Object) {
        if (val instanceof Date) {
          return val.toISOString();
        }

        return flattenRecurse(val);
      }

      return val;
    });
  };

  return flatDeep(flattenRecurse(obj));
}

export function flatDeep(arr: any[]): any[] {
  return arr.reduce(
    (acc, val) => acc.concat(Array.isArray(val) ? flatDeep(val) : val),
    [],
  );
}

/**
 * Parse a JWT token and return an object
 * @param token The access token to decode
 */
export function parseJwt(token: string): { [key: string]: any } {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    Buffer.from(base64, 'base64')
      .toString()
      .split('')
      .map((c: string) => {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join(''),
  );

  return JSON.parse(jsonPayload);
}

export function EnumTranslate(key: string) {
  return Reflect.metadata('translate-enum', key);
}

export function formatDate(date: Date): string {
  return date && date instanceof Date
    ? ('0' + date.getDate()).slice(-2) +
        '.' +
        ('0' + (date.getMonth() + 1)).slice(-2) +
        '.' +
        date.getFullYear()
    : '';
}

export function dateFormatISO8601(dt: Date) {
  if (dt == null) {
    dt = new Date();
  }
  const dd = dt.getDate(),
    mm = dt.getMonth() + 1,
    yyyy = dt.getFullYear(),
    hour = dt.getHours(),
    minutes = dt.getMinutes(),
    seconds = dt.getSeconds(),
    elts: Array<string> = [
      yyyy.toString(),
      mm.toString(),
      dd.toString(),
      hour.toString(),
      minutes.toString(),
      seconds.toString(),
    ];

  if (hour < 10) elts[3] = '0' + hour;
  if (minutes < 10) elts[4] = '0' + minutes;
  if (seconds < 10) elts[5] = '0' + seconds;
  if (dd < 10) elts[2] = '0' + dd;
  if (mm < 10) elts[1] = '0' + mm;

  return (
    elts[0] +
    '-' +
    elts[1] +
    '-' +
    elts[2] +
    'T' +
    elts[3] +
    ':' +
    elts[4] +
    ':' +
    elts[5] +
    'Z'
  );
}

export function dateFormatRFC3339(dt: Date) {
  if (dt == null) {
    dt = new Date();
  }
  const dd = dt.getDate(),
    mm = dt.getMonth() + 1,
    yyyy = dt.getFullYear(),
    hour = dt.getHours(),
    minutes = dt.getMinutes(),
    seconds = dt.getSeconds(),
    elts: Array<string> = [
      yyyy.toString(),
      mm.toString(),
      dd.toString(),
      hour.toString(),
      minutes.toString(),
      seconds.toString(),
    ];

  let offset = '',
    n = dt.getTimezoneOffset() / 60;

  if (hour < 10) elts[3] = '0' + hour;
  if (minutes < 10) elts[4] = '0' + minutes;
  if (seconds < 10) elts[5] = '0' + seconds;
  if (dd < 10) elts[2] = '0' + dd;
  if (mm < 10) elts[1] = '0' + mm;
  if (n > 0) offset = '-';
  else {
    offset = '+';
    n = -1 * n;
  }
  if (n < 9) offset += '0' + n;
  else offset += n;
  return (
    elts[0] +
    '-' +
    elts[1] +
    '-' +
    elts[2] +
    'T' +
    elts[3] +
    ':' +
    elts[4] +
    ':' +
    elts[5] +
    offset +
    ':00'
  );
}

export function getAcceptedLanguageEnumFromLanguageCode(
  languageCode: string,
): AcceptedLanguage {
  const index = Object.values(AcceptedLanguage).indexOf(
    languageCode as unknown as AcceptedLanguage,
  );

  const key = Object.keys(AcceptedLanguage)[index];
  return AcceptedLanguage[key as keyof typeof AcceptedLanguage];
}
